// src/components/landing/Placeholder.jsx
import React from 'react';

/**
 * A slot for a figure, logo, photo or screenshot VAUOM cannot yet back.
 *
 * Rendered as its literal {{…}} token, dashed, on purpose. A placeholder that
 * looks finished is the easiest way for an unverified number to reach an
 * investor; this one cannot be mistaken for real copy. Every slot still waiting
 * for a real asset can be listed with
 *   document.querySelectorAll('[data-placeholder]')
 */
export default function Placeholder({ children, block = false, className = '' }) {
  const Tag = block ? 'div' : 'span';
  return (
    <Tag
      className={`lp-ph${block ? ' lp-ph--block' : ''}${className ? ` ${className}` : ''}`}
      data-placeholder=""
      title="Placeholder — replace with a verified figure or asset before this page is published"
    >
      {`{{${children}}}`}
    </Tag>
  );
}
